import { Component, OnDestroy, OnInit } from '@angular/core';
import {OrderItem} from '../../../../shared-gen/Model/Orders/OrderItem';
import {Menu} from '../../../../shared-gen/Model/Menus/Menu';
import {VmcState} from '../../../../shared-gen/Vending/Status/VmcState';
import {MenuFun} from '../../../../shared/model/menus/menu.fun';
import {AppService} from '../../../services/app.service';
import {StatusListener} from "../../../status-listener";
import {AppStatus} from "../../../@models/app-status";

@Component({
	selector: 'cart',
	templateUrl: './cart.component.html',
	styleUrls: ['./cart.component.scss']
})
export class CartComponent extends StatusListener implements OnInit, OnDestroy {

	cart: OrderItem[];
	menu: Menu;
	state = VmcState.Intervention;

	visibleItems: OrderItem[] = [null, null, null, null];
	count: number = 0;

	constructor(app: AppService) {
		super(app);
	}

	onStatusChanged(status: AppStatus) {
		super.onStatusChanged(status);
		const vending = status.deviceStatus.VendingStatus;
		this.menu = status.menu;
		this.state = vending.VmcState;

		let cart = vending.Cart.Items;

		this.visibleItems = [];
		this.cart = cart;
		this.countCart();
		let i = 0;
		while (this.visibleItems.length < 4) {
			if (i < cart.length && cart[i]) {
				this.visibleItems.push(cart[i]);
			} else {
				this.visibleItems.push(null);
			}
			i++;
		}

	}

	async remove(item: OrderItem) {
		if (item) {
			let api = this.app.api;
			await api.cartApi.remove(item.Product.ID);
			await api.orderApi.cancel(false);
			await api.orderApi.orderCart();
		}
	}

	getImage(item: OrderItem) {
		if (item) {
			const base = MenuFun.findProductBase(this.menu, item.Product);
			return this.app.api.dataApi.getImageUrl(base.Image);
		}
	}

	countCart() {
		this.count = 0;
		if (this.cart)
			this.count = this.cart.length;
	}

}
